import React from 'react';
import PropTypes from 'prop-types';
import {
  MapContainer, CircleMarker, GeoJSON, Popup,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import { CENTER_OF_THIS_EARTH, RELATIVE, VALUE } from '../../../constants';
import calculateStrokeWidth from '../../../utils/calculateStrokeWidth';

export default class MapView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLocation: CENTER_OF_THIS_EARTH,
      zoom: 2,
    };
  }

  static onEachCountry(country, layer) {
    const { ADMIN: countryName } = country.properties;
    layer.setStyle({
      fillColor: '#2a2a28',
    });
    layer.on({
      mouseover: (event) => {
        const { param, period, quality } = event.target.options;
        let cases = event.target.feature.properties[period + param];
        if (quality === RELATIVE) {
          const { population } = event.target.feature.properties;
          cases = Math.round((cases * VALUE) / population);
        }
        event.target.bindPopup(`${countryName} ${period} ${param} ${cases} ${quality}`, {
          closeButton: false,
        });
        event.target.openPopup();
        event.target.setStyle({
          fillColor: '#173a56',
        });
      },
      mouseout: (event) => {
        event.target.closePopup();
        event.target.setStyle({
          fillColor: '#2a2a28',
        });
      },
    });
  }

  render() {
    const {
      currentLocation, zoom,
    } = this.state;
    const {
      geoMarkers, geoCountries, param, period, quality,
    } = this.props;

    const copyGeoMarkers = calculateStrokeWidth(geoMarkers, quality, param, period);
    const popUpInfo = {
      param,
      period,
      quality,
    };
    return (
      <MapContainer
        center={currentLocation}
        zoom={zoom}
      >
        <GeoJSON
          data={geoCountries}
          className="geo"
          onEachFeature={MapView.onEachCountry}
          pathOptions={popUpInfo}
        />
        {copyGeoMarkers.features.map((country) => {
          const { geometry: { coordinates }, properties } = country;
          let radius = 1;
          if (properties.stroke) {
            radius = properties.stroke;
          }
          const { markerColor } = properties;
          return (
            <CircleMarker
              className="circle"
              center={coordinates}
              radius={radius}
              key={properties.key}
              color={markerColor}
            >
              <Popup>
                {
                  `${properties.Country}
                  ${properties.currentPeriod}
                  ${properties.currentParam}:
                  ${properties[properties.currentPeriod + properties.currentParam]}`
                }
              </Popup>
            </CircleMarker>
          );
        })}
      </MapContainer>
    );
  }
}

MapView.propTypes = {
  geoMarkers: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      properties: PropTypes.shape({
        flag: PropTypes.string,
        iso2: PropTypes.string,
        iso3: PropTypes.string,
        _id: PropTypes.number,
        Country: PropTypes.string,
        CountryCode: PropTypes.string,
        Date: PropTypes.string,
        Slug: PropTypes.string,
        center: PropTypes.arrayOf(PropTypes.number),
        lat: PropTypes.number,
        long: PropTypes.number,
        NewConfirmed: PropTypes.number,
        NewDeaths: PropTypes.number,
        NewRecovered: PropTypes.number,
        TotalConfirmed: PropTypes.number,
        TotalDeaths: PropTypes.number,
        TotalRecovered: PropTypes.number,
      }),
    })),
    geometry: PropTypes.shape({
      type: PropTypes.string,
      coordinates: PropTypes.arrayOf(PropTypes.number),
    }),
  }).isRequired,
  geoCountries: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      properties: PropTypes.shape({
        ADMIN: PropTypes.string,
        ISO_A3: PropTypes.string,
        NewConfirmed: PropTypes.number,
        NewDeaths: PropTypes.number,
        NewRecovered: PropTypes.number,
        TotalConfirmed: PropTypes.number,
        TotalDeaths: PropTypes.number,
        TotalRecovered: PropTypes.number,
      }),
    })),
    geometry: PropTypes.shape({
      type: PropTypes.string,
      coordinates: PropTypes.arrayOf(
        PropTypes.arrayOf(
          PropTypes.arrayOf(
            PropTypes.arrayOf(PropTypes.number),
          ),
        ),
      ),
    }),
  }).isRequired,
  param: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  quality: PropTypes.string.isRequired,
};
